<div class="gains-date-picker">
  <gains-input-title *ngIf="label" [for]="inputId" [label]="label" [required]="required"></gains-input-title>

  <div [ngClass]="{ 'error-input': displayError }">
    <!-- Date picker. -->
    <nz-date-picker
      [nzFormat]="format"
      (nzOnOpenChange)="this.onPanelChanged($event)"
      (ngModelChange)="onValueChange($event)"
      [nzPlaceHolder]="placeholder"
      [formControl]="internalFormControl"
      [nzAllowClear]="allowClear"
      [nzShowTime]="showTime"
      [nzId]="inputId"
    ></nz-date-picker>
  </div>

  <div class="error-message" *ngFor="let message of errorMessagesToDisplay">
    <svg-icon src="assets/icons/exclamation-circle.svg"></svg-icon>
    <span>{{ message }}</span>
  </div>
</div>
